<!-- ======= Start Banner ======= -->
<section id="hero" class="imgClass" [ngStyle]="backgroundStyle">
    <div class="container banner-container">
        <div class="row">
            <div class="col-lg-12 order-sm-1 order-md-1 order-lg-2 d-flex flex-column rvh-journal-banner-content">
                <div class="d-flex">
                    <img data-aos="fade-up" data-aos-delay="20" src="assets/logos/ba_logo_monogram.webp"  fetchpriority="high"
                        class="banner-logo" alt="">
                    <h2 data-aos="fade-down" data-aos-delay="20" class="banner-primary-heading mb-3 top-left-content">
                        <!-- <ng-container *ngIf="themeSettingsData.banner_heading.includes(' ')"> -->
                        <span class="text-content">Journal of the</span><br />
                        <span class="text-content">British Academy</span>
                        <!-- </ng-container> -->
                        <!-- <ng-container *ngIf="!themeSettingsData.banner_heading.includes(' ')"> -->
                        <!-- <span class="text-content">{{ themeSettingsData.banner_heading }}</span> -->
                        <!-- </ng-container> -->
                    </h2>
                </div>
                <!-- <h3
                data-aos="fade-up"
                data-aos-delay="200"
                class="banner-secondary_content mb-4 text-content top-left-content-sub"
                *ngIf="themeSettingsData && themeSettingsData.banner_content"
                tabindex="0"
                [innerHTML]="themeSettingsData.banner_content"
                ></h3> -->
                <div class="banner-secondary_content mb-4 text-content top-left-content-sub1 ">
                    <span data-aos="fade-right" data-aos-delay="10" class="rvh-banner-sub-titile color-change">Connecting
                        knowledge</span>
                    <span data-aos="fade-left" data-aos-delay="20" class="rvh-banner-sub-titile color-change">Deepening
                        inquiry</span>
                    <span data-aos="fade-right" data-aos-delay="30" class="rvh-banner-sub-titile color-change">Pushing
                        boundaries</span>
                </div>
                <!-- <h3 data-aos="fade-up" data-aos-delay="200"
                    class="banner-secondary_content mb-4 text-content top-left-content-sub1" tabindex="0"
                    >Connecting knowledge.</h3><br/>
                <h3 data-aos="fade-up" data-aos-delay="200"
                    class="banner-secondary_content mb-4 text-content top-left-content-sub2" tabindex="0"
                    >Deepening inquiry.</h3><br/>
                <h3 data-aos="fade-up" data-aos-delay="200"
                    class="banner-secondary_content mb-4 text-content top-left-content-sub3" tabindex="0"
                    >Pushing boundaries.</h3> -->
            </div>
            <!-- <div class="col-lg-12 order-sm-1 order-md-1 order-lg-2 d-flex flex-column justify-content-left " >
                <span data-aos="fade-up" data-aos-delay="200"
                    class="banner-secondary_content mb-4 text-content top-left-content-sub"
                    *ngIf="themeSettingsData && themeSettingsData.banner_secondary_content"
                    [innerHTML]="themeSettingsData.banner_secondary_content"></span>
                <div data-aos="fade-up" data-aos-delay="300" *ngIf="themeSettingsData.button_label">
                    <a title="{{ themeSettingsData.button_label }}"
                        [routerLink]="['{{ themeSettingsData.button_link }}']" class="btn-get-started scrollto primary"
                        role="link" [innerHTML]="themeSettingsData.button_label"></a>
                </div>
            </div>
            <div class="col-lg-6 order-1 order-lg-2 hero-img d-none" data-aos="fade-left" data-aos-delay="200">
                <div class="col-sm col-md img-padding rvh-journal-transparent-sec" data-aos="fade-left"
                    data-aos-delay="200">
                    <img class="float-start mg-fluid animated rvh-journal-transparent-img"
                        *ngIf="themeSettingsData.banner_type === 'Transparent'"
                        [src]="themeimageUrl + themeSettingsData.banner_transparent_image"
                        [alt]="themeSettingsData.banner_trans_alt_text" />
                </div>
            </div> -->
        </div>
    </div>
</section>
<!-- ======= End Banner ======= -->


<!-- ======= Main Section ======= -->
<main id="main">

    <!-- ======= Recent Articles Loader Section Start  ======= -->
    
        <!-- ======= Loader Starts ======= -->
        <section class="explore-content" aria-hidden="true" *ngIf="loadingForArticle">
            <div class="container">
                <div class="card article-search-card">
                    <div class="card-body">
                        <div class="section-title hide-before-after">
                            <h2 *ngIf="loadingForArticle" class=" primary">
                                <span class="loader section-title">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </h2>
                            <div style="min-width: 100%;">
                                <div>
                                    <span class="loader about-content">
                                        &nbsp;
                                    </span>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <!-- First Column -->
                            <div class="col-lg 6 col-xl-6 col-xxl-6 col-md-12  pr-5 pr-md-0 mt-3 article-card-right">
                                <div class="article-box" style="width: 100%;">
                                    <!-- Image and Title -->
                                    <div class="article-info">
                                        <img class="article-explore-image loader" style="width: 100%;">

                                        <div class="col">
                                            <div class="row">
                                                <div class="col-11 col-md-10">
                                                    <a class="loader">
                                                        &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    </a>
                                                </div>
                                                <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                    <img class="articlelist-open-access-logo loader"  width="25" height="25">
                                                </div>
                                            </div>

                                        </div>

                                        <h3 class="loader">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </h3>

                                        <div [ngClass]=" 'explore-content loader' ">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </div>
                                    </div>

                                    <div class="row mt-2 mb-0">
                                        <div class="col-6 doi-content-div">

                                            <span class="article-doi">

                                                <a class="loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </a>
                                            </span>
                                        </div>
                                        <div class="col-6 text-end doi-content-div">
                                            <span class="loader"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Second Column -->
                            <div class="col-lg 6 col-xl-6 col-xxl-6 col-md-12  pl-5 mt-3 article-card-left  ">
                                <div class="article-box-second article-box-second-first article-second-left "
                                    style="width: 100%;">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img class="article-explore-image loader" style="width: 100%;">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12 ">

                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            </a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img class="articlelist-open-access-logo-second loader"  width="25" height="25">
                                                        </div>
                                                    </div>
                                                </div>


                                                <h3 class="sub-title loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </h3>
                                                <div class="explore-content-second loader">
                                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                    &nbsp; &nbsp; &nbsp; &nbsp;
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi">
                                                            <a class="loader">
                                                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi loader">
                                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                            &nbsp; &nbsp; &nbsp; &nbsp;
                                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="article-box-second article-second-top">
                                    <!-- Image, Title, and Content for the second article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img class="article-explore-image loader" style="width: 100%;">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            </a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img class="articlelist-open-access-logo-second"  width="25" height="25"
                                                                style="width: 100%;">
                                                        </div>
                                                    </div>
                                                </div>
                                                <h3 class="sub-title loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </h3>

                                                <div class="explore-content-second loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi">
                                                            <a class="loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class=" col-md-6 pr-5 article-card-right">
                                <div class="article-box-second " style="width: 104%;">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img class="article-explore-image loader" style="width: 100%;">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            </a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img class="articlelist-open-access-logo-second loader"  width="25" height="25">
                                                        </div>
                                                    </div>
                                                </div>

                                                <h3 class="sub-title loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </h3>

                                                <div class="explore-content-second loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi loader">
                                                            <a class="loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi loader">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        </span>
                                                        <span class="article-doi loader">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-6 article-card-last">
                                <div class="article-box-second article-box-second-space-between">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img class="article-explore-image loader" style="width: 100%;">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                            </a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img class="articlelist-open-access-logo-second loader"  width="25" height="25">
                                                        </div>
                                                    </div>
                                                </div>


                                                <h3 class="sub-title loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </h3>

                                                <div class="explore-content-second loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi ">
                                                            <a class="loader">
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi loader">
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                                                        </span>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center" *ngIf="loadingForArticle">
                    <a class="loader-btn  loader">
                        <span class="icon">
                            <!-- <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon> -->
                        </span>
                        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                    </a>
                </div>

            </div>
        </section>
        <!-- ======= Loader Ends ======= -->

        <section id="explore-content" class="explore-content" aria-label="explore-content"
            *ngIf="!loadingForArticle && articleData[0]">
            <div class="container">
                <div class="card article-search-card" data-aos="fade-up">
                    <div class="card-body">
                        <div class="section-title" data-aos="fade-up">
                            <h2 class="primary">{{'journal_home.explore_content' | translate}}</h2>
                            <p class="rvh-sub-heading">{{'journal_home.explore_inner_content' | translate}}</p>
                        </div>
                        <div class="row">
                            <!-- First Column -->
                            <div class="col-lg 6 col-xl-6 col-xxl-6 col-md-12  pr-5 pr-md-0 mt-3 article-card-right">
                                <div class="article-box" *ngIf="articleData[0]">
                                    <!-- Image and Title -->
                                    <div class="article-info">
                                        <img *ngIf=" articleData[0].article_cover_image" class="article-explore-image"
                                            [routerLink]="['/articles/' + articleData[0].volume + '/' + articleData[0].issue + '/' + articleData[0].article_id]"
                                            src="{{articleCoverImageUrl+getArticleImageUrl(articleData[0])}}"
                                            alt="Cover image for the article">
                                        <img *ngIf=" !articleData[0].article_cover_image && +articleData[0].volume <= 11"
                                            class="card-img-top rvh-article-default-cover"
                                            src="{{default_article_cover_image_upto_11}}"
                                            alt="Cover image for the article"
                                            [routerLink]="['/articles/' + articleData[0].volume + '/' + articleData[0].issue + '/' + articleData[0].article_id]">
                                        <img *ngIf=" !articleData[0].article_cover_image && +articleData[0].volume > 11"
                                            class="card-img-top rvh-article-default-cover-green"
                                            src="{{default_article_cover_image_above_11}}"
                                            alt="Cover image for the article"
                                            [routerLink]="['/articles/' + articleData[0].volume + '/' + articleData[0].issue + '/' + articleData[0].article_id]">

                                        <div class="col">
                                            <div class="row">
                                                <div class="col-11 col-md-10">
                                                    <a [ngClass]="articleData[3] ? 'heading-title' : 'heading-title'"
                                                        [title]=" getCleanTitle(articleData[0].article_title)"
                                                        [routerLink]="['/articles/' + articleData[0].volume + '/' + articleData[0].issue + '/' + articleData[0].article_id]"
                                                        [innerHTML]="getFormattedTitle(articleData[0].article_title)">
                                                    </a>
                                                </div>
                                                <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                    <img src='assets/logos/open_access_logo.webp'
                                                        class="articlelist-open-access-logo"  width="25" height="25"
                                                        [ngbTooltip]="'article_listing.open_access'|translate"
                                                        [placement]="'bottom'" alt="open access logo">
                                                </div>
                                            </div>

                                        </div>
                                        <!-- <h3 *ngIf="!loadingForArticle" [ngClass]="articleData[3] ? 'title' : 'title'"
                                            [routerLink]="['/journal/' + journalid + '/articles/' + articleData[0].volume + '/' + articleData[0].issue + '/' + articleData[0].article_id]">
                                            {{ articleData[0].article_title }}
                                        </h3> -->
                                        <!-- <img src='assets/logos/open_access_logo.png' class="articlelist-open-access-logo"
                                            title="Open Access" alt="open access logo"> -->

                                        <h3 [ngClass]="articleData[3] ? 'sub-title' : 'sub-title'">{{
                                            getAuthorsString(articleData[0].authors) }} </h3>

                                        <div [ngClass]="articleData[3] ? 'explore-content' : 'explore-content'"
                                            [innerHTML]="articleData[0].abstract"></div>
                                    </div>

                                    <div class="row mt-2 mb-0">
                                        <div class="col-6 doi-content-div">

                                            <span class="article-doi">

                                                <a [href]="ensureHttps(articleData[0].doi)" target="_blank"
                                                    [title]="ensureHttps(articleData[0].doi)" class="doi-underline">
                                                    <fa-icon class="iconcls" aria-hidden="true"
                                                        [icon]="['fas', 'earth-americas']"></fa-icon>
                                                    {{articleData[0].doi}}
                                                </a>
                                            </span>
                                        </div>
                                        <div class="col-6 text-end doi-content-div">
                                            <span class="article-doi"
                                                [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                [placement]="'bottom'"><fa-icon class="iconcls" aria-hidden="true"
                                                    [icon]="['fas', 'calendar-days']"></fa-icon> {{
                                                removeCommaFromDate(articleData[0].published_online) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Second Column -->
                            <div class="col-lg 6 col-xl-6 col-xxl-6 col-md-12 pl-5 mt-3 article-card-left  d-md-none d-lg-block ">
                                <div class="article-box-second article-box-second-first article-second-left"
                                    *ngIf="articleData[1]">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-6 col-sm-12 m-0">

                                                <img *ngIf=" articleData[1].article_cover_image"
                                                    class="article-explore-image"
                                                    src="{{articleCoverImageUrl+getArticleImageUrl(articleData[1])}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/'+articleData[1].volume+'/'+articleData[1].issue+'/'+articleData[1].article_id]">
                                                <img *ngIf=" !articleData[1].article_cover_image && +articleData[1].volume <= 11"
                                                    class="card-img-top rvh-article-default-cover"
                                                    src="{{default_article_cover_image_upto_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[1].volume + '/' + articleData[1].issue + '/' + articleData[1].article_id]">
                                                <img *ngIf=" !articleData[1].article_cover_image && +articleData[1].volume >11"
                                                    class="card-img-top rvh-article-default-cover-green"
                                                    src="{{default_article_cover_image_above_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[1].volume + '/' + articleData[1].issue + '/' + articleData[1].article_id]">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-6 col-sm-12 ">

                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title"
                                                                [title]=" getCleanTitle(articleData[1].article_title)"
                                                                [routerLink]="['/articles/'+articleData[1].volume+'/'+articleData[1].issue+'/'+articleData[1].article_id]"
                                                                [appWordClamp]="getFormattedTitle(articleData[1].article_title)">
                                                                {{ getCleanTitle(articleData[1].article_title) }}
                                                            </a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img src='assets/logos/open_access_logo.webp'
                                                                class="articlelist-open-access-logo-second" width="25" height="25"
                                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                                [placement]="'bottom'" alt="open access logo">
                                                        </div>
                                                    </div>
                                                </div>


                                                <h3 class="!loader" class="sub-title">{{
                                                    getAuthorsString(articleData[1].authors) }} </h3>

                                                <div class="explore-content-second" [innerHTML]="articleData[1].abstract">
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">

                                                        <span class="article-doi">

                                                            <a [href]="ensureHttps(articleData[1].doi)" target="_blank"
                                                                [title]=" ensureHttps(articleData[1].doi)"
                                                                class="doi-underline">
                                                                <fa-icon class="iconcls" aria-hidden="true"
                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                {{articleData[1].doi}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi"
                                                            [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                            [placement]="'bottom'"><fa-icon class="iconcls"
                                                                aria-hidden="true"
                                                                [icon]="['fas', 'calendar-days']"></fa-icon> {{
                                                            removeCommaFromDate(articleData[1].published_online) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="article-box-second article-second-top" *ngIf="articleData[2]">
                                    <!-- Image, Title, and Content for the second article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-6 col-sm-12 m-0">
                                                <img *ngIf="  articleData[2].article_cover_image"
                                                    class="article-explore-image"
                                                    src="{{articleCoverImageUrl+getArticleImageUrl(articleData[2])}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/'+articleData[2].volume+'/'+articleData[2].issue+'/'+articleData[2].article_id]">
                                                <img *ngIf=" !articleData[2].article_cover_image && +articleData[2].volume <= 11"
                                                    class="card-img-top rvh-article-default-cover"
                                                    src="{{default_article_cover_image_upto_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[2].volume + '/' + articleData[2].issue + '/' + articleData[2].article_id]">
                                                <img *ngIf=" !articleData[2].article_cover_image && +articleData[2].volume >11"
                                                    class="card-img-top rvh-article-default-cover-green"
                                                    src="{{default_article_cover_image_above_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[2].volume + '/' + articleData[2].issue + '/' + articleData[2].article_id]">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-6 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title"
                                                                [title]=" getCleanTitle(articleData[2].article_title)"
                                                                [routerLink]="['/articles/'+articleData[2].volume+'/'+articleData[2].issue+'/'+articleData[2].article_id]"
                                                                [appWordClamp]="getFormattedTitle(articleData[2].article_title)">
                                                                {{ getCleanTitle(articleData[2].article_title) }}</a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img src='assets/logos/open_access_logo.webp' 
                                                                class="articlelist-open-access-logo-second" width="25" height="25"
                                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                                [placement]="'bottom'" alt="open access logo">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- <h3 *ngIf="!loadingForArticle" class="second-title"
                                                    [routerLink]="['/journal/'+journalid+ '/articles/'+articleData[2].volume+'/'+articleData[2].issue+'/'+articleData[2].article_id]">
                                                    {{articleData[2].article_title}}</h3> -->
                                                <h3 class="sub-title">{{
                                                    getAuthorsString(articleData[2].authors) }} </h3>

                                                <div class="explore-content-second" [innerHTML]="articleData[2].abstract">
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi">
                                                            <a [href]="ensureHttps(articleData[2].doi)" target="_blank"
                                                                [title]=" ensureHttps(articleData[2].doi)"
                                                                class="doi-underline">
                                                                <fa-icon class="iconcls" aria-hidden="true"
                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                {{articleData[2].doi}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi"><fa-icon class="iconcls"
                                                                aria-hidden="true" [icon]="['fas', 'calendar-days']"
                                                                [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                                [placement]="'bottom'"></fa-icon> {{
                                                            removeCommaFromDate(articleData[2].published_online) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row d-xs-none d-sm-none d-md-flex d-lg-none">
                            <div class=" col-md-6 pr-5 article-card-right mb-0">
                                <div class="article-box-second " *ngIf="articleData[1]">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img *ngIf=" articleData[1].article_cover_image"
                                                    class="article-explore-image"
                                                    src="{{articleCoverImageUrl+getArticleImageUrl(articleData[1])}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/'+articleData[1].volume+'/'+articleData[1].issue+'/'+articleData[1].article_id]">
                                                <img *ngIf=" !articleData[1].article_cover_image && +articleData[1].volume <= 11"
                                                    class="card-img-top rvh-article-default-cover"
                                                    src="{{default_article_cover_image_upto_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[1].volume + '/' + articleData[1].issue + '/' + articleData[1].article_id]">
                                                <img *ngIf=" !articleData[1].article_cover_image && +articleData[1].volume >11"
                                                    class="card-img-top rvh-article-default-cover-green"
                                                    src="{{default_article_cover_image_above_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[1].volume + '/' + articleData[3].issue + '/' + articleData[1].article_id]">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title"
                                                                [title]=" getCleanTitle(articleData[1].article_title)"
                                                                [routerLink]="['/articles/'+articleData[1].volume+'/'+articleData[1].issue+'/'+articleData[1].article_id]"
                                                                [appWordClamp]="getFormattedTitle(articleData[1].article_title)">
                                                                {{ getCleanTitle(articleData[1].article_title) }}</a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img src='assets/logos/open_access_logo.webp'
                                                                class="articlelist-open-access-logo-second"  width="25" height="25"
                                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                                [placement]="'bottom'" alt="open access logo">
                                                        </div>
                                                    </div>
                                                </div>

                                                <h3 class="sub-title">{{
                                                    getAuthorsString(articleData[1].authors) }} </h3>

                                                <div class="explore-content-second" [innerHTML]="articleData[1].abstract">
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi">
                                                            <a [href]="ensureHttps(articleData[1].doi)" target="_blank"
                                                                [title]=" ensureHttps(articleData[1].doi)"
                                                                class="doi-underline">
                                                                <fa-icon class="iconcls" aria-hidden="true"
                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                {{articleData[1].doi}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi"><fa-icon class="iconcls"
                                                                aria-hidden="true" [icon]="['fas', 'calendar-days']"
                                                                [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                                [placement]="'bottom'"></fa-icon> {{
                                                            removeCommaFromDate(articleData[1].published_online) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-6 article-card-last mb-0">
                                <div class="article-box-second article-box-second-space-between" *ngIf="articleData[2]">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img *ngIf=" articleData[2].article_cover_image"
                                                    class="article-explore-image"
                                                    src="{{articleCoverImageUrl+getArticleImageUrl(articleData[2])}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/'+articleData[2].volume+'/'+articleData[2].issue+'/'+articleData[2].article_id]">
                                                <img *ngIf=" !articleData[2].article_cover_image && +articleData[2].volume <= 11"
                                                    class="card-img-top rvh-article-default-cover"
                                                    src="{{default_article_cover_image_upto_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[2].volume + '/' + articleData[2].issue + '/' + articleData[2].article_id]">
                                                <img *ngIf=" !articleData[2].article_cover_image && +articleData[2].volume >11"
                                                    class="card-img-top rvh-article-default-cover-green"
                                                    src="{{default_article_cover_image_above_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[2].volume + '/' + articleData[2].issue + '/' + articleData[2].article_id]">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title"
                                                                [title]=" getCleanTitle(articleData[2].article_title)"
                                                                [routerLink]="['/articles/'+articleData[2].volume+'/'+articleData[2].issue+'/'+articleData[2].article_id]"
                                                                [appWordClamp]="getFormattedTitle(articleData[2].article_title)">
                                                                {{ getCleanTitle(articleData[2].article_title) }}</a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img src='assets/logos/open_access_logo.webp'
                                                                class="articlelist-open-access-logo-second"  width="25" height="25"
                                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                                [placement]="'bottom'" alt="open access logo">
                                                        </div>
                                                    </div>
                                                </div>


                                                <h3 class="sub-title">{{
                                                    getAuthorsString(articleData[2].authors) }} </h3>

                                                <div class="explore-content-second" [innerHTML]="articleData[2].abstract">
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi ">
                                                            <a [href]="ensureHttps(articleData[2].doi)" target="_blank"
                                                                [title]=" ensureHttps(articleData[2].doi)"
                                                                class="doi-underline">
                                                                <fa-icon class="iconcls" aria-hidden="true"
                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                {{articleData[2].doi}}
                                                            </a></span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi"
                                                            [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                            [placement]="'bottom'"><fa-icon class="iconcls"
                                                                aria-hidden="true"
                                                                [icon]="['fas', 'calendar-days']"></fa-icon> {{
                                                            removeCommaFromDate(articleData[2].published_online) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div class="row">
                            <div class=" col-md-6 pr-5 article-card-right">
                                <div class="article-box-second " *ngIf="articleData[3]">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img *ngIf=" articleData[3].article_cover_image"
                                                    class="article-explore-image"
                                                    src="{{articleCoverImageUrl+getArticleImageUrl(articleData[3])}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/'+articleData[3].volume+'/'+articleData[3].issue+'/'+articleData[3].article_id]">
                                                <img *ngIf=" !articleData[3].article_cover_image && +articleData[3].volume <= 11"
                                                    class="card-img-top rvh-article-default-cover"
                                                    src="{{default_article_cover_image_upto_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[3].volume + '/' + articleData[3].issue + '/' + articleData[3].article_id]">
                                                <img *ngIf=" !articleData[3].article_cover_image && +articleData[3].volume >11"
                                                    class="card-img-top rvh-article-default-cover-green"
                                                    src="{{default_article_cover_image_above_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[3].volume + '/' + articleData[3].issue + '/' + articleData[3].article_id]">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title"
                                                                [title]=" getCleanTitle(articleData[3].article_title)"
                                                                [routerLink]="['/articles/'+articleData[3].volume+'/'+articleData[3].issue+'/'+articleData[3].article_id]"
                                                                [appWordClamp]="getFormattedTitle(articleData[3].article_title)">
                                                                {{ getCleanTitle(articleData[3].article_title) }}</a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img src='assets/logos/open_access_logo.webp'
                                                                class="articlelist-open-access-logo-second"  width="25" height="25"
                                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                                [placement]="'bottom'" alt="open access logo">
                                                        </div>
                                                    </div>
                                                </div>

                                                <h3 class="sub-title">{{
                                                    getAuthorsString(articleData[3].authors) }} </h3>

                                                <div class="explore-content-second" [innerHTML]="articleData[3].abstract">
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi">
                                                            <a [href]="ensureHttps(articleData[3].doi)" target="_blank"
                                                                [title]=" ensureHttps(articleData[3].doi)"
                                                                class="doi-underline">
                                                                <fa-icon class="iconcls" aria-hidden="true"
                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                {{articleData[3].doi}}
                                                            </a>
                                                        </span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi"><fa-icon class="iconcls"
                                                                aria-hidden="true" [icon]="['fas', 'calendar-days']"
                                                                [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                                [placement]="'bottom'"></fa-icon> {{
                                                            removeCommaFromDate(articleData[3].published_online) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-6 article-card-last">
                                <div class="article-box-second article-box-second-space-between" *ngIf="articleData[4]">
                                    <!-- Image, Title, and Content for the first article -->
                                    <div class="article-info-second">
                                        <div class="row">
                                            <div class="col-lg-4 col-xl-4 col-xxl-4 col-md-12 col-sm-12 m-0">
                                                <img *ngIf=" articleData[4].article_cover_image"
                                                    class="article-explore-image"
                                                    src="{{articleCoverImageUrl+getArticleImageUrl(articleData[4])}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/'+articleData[4].volume+'/'+articleData[4].issue+'/'+articleData[4].article_id]">
                                                <img *ngIf=" !articleData[4].article_cover_image && +articleData[4].volume <= 11"
                                                    class="card-img-top rvh-article-default-cover"
                                                    src="{{default_article_cover_image_upto_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[4].volume + '/' + articleData[4].issue + '/' + articleData[4].article_id]">
                                                <img *ngIf=" !articleData[4].article_cover_image && +articleData[4].volume >11"
                                                    class="card-img-top rvh-article-default-cover-green"
                                                    src="{{default_article_cover_image_above_11}}"
                                                    alt="Cover image for the article"
                                                    [routerLink]="['/articles/' + articleData[4].volume + '/' + articleData[4].issue + '/' + articleData[4].article_id]">
                                            </div>
                                            <div class="col-lg-8 col-xl-8 col-xxl-8 col-md-12 col-sm-12">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col-11 col-md-10">
                                                            <a class="second-title"
                                                                [title]=" getCleanTitle(articleData[4].article_title)"
                                                                [routerLink]="['/articles/'+articleData[4].volume+'/'+articleData[4].issue+'/'+articleData[4].article_id]"
                                                                [appWordClamp]="getFormattedTitle(articleData[4].article_title)">
                                                                {{ getCleanTitle(articleData[4].article_title) }}</a>
                                                        </div>
                                                        <div class="col-1 col-md-2 d-flex justify-content-end pl-0">
                                                            <img src='assets/logos/open_access_logo.webp'
                                                                class="articlelist-open-access-logo-second"  width="25" height="25"
                                                                [ngbTooltip]="'article_listing.open_access'|translate"
                                                                [placement]="'bottom'" alt="open access logo">
                                                        </div>
                                                    </div>
                                                </div>


                                                <h3 class="sub-title">{{
                                                    getAuthorsString(articleData[4].authors) }} </h3>

                                                <div class="explore-content-second" [innerHTML]="articleData[4].abstract">
                                                </div>
                                                <div class="row mt-2 mb-0">
                                                    <div class="col-6 doi-content-div">
                                                        <span class="article-doi ">
                                                            <a [href]="ensureHttps(articleData[4].doi)" target="_blank"
                                                                [title]=" ensureHttps(articleData[4].doi)"
                                                                class="doi-underline">
                                                                <fa-icon class="iconcls" aria-hidden="true"
                                                                    [icon]="['fas', 'earth-americas']"></fa-icon>
                                                                {{articleData[4].doi}}
                                                            </a></span>
                                                    </div>
                                                    <div class="col-6 text-end doi-content-div">
                                                        <span class="article-doi"
                                                            [ngbTooltip]="'article_listing.publisher_date'|translate"
                                                            [placement]="'bottom'"><fa-icon class="iconcls"
                                                                aria-hidden="true"
                                                                [icon]="['fas', 'calendar-days']"></fa-icon> {{
                                                            removeCommaFromDate(articleData[4].published_online) }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-center pt-5 splitexplore">
                    <a class="explore-button icon-explore" [routerLink]="['/current-articles']"
                        title=" {{'journal_home.explore_button_current' | translate}}">
                        <span>
                            <!-- <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon> -->
                        </span>
                        {{'journal_home.explore_button_current' | translate}}
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a class="explore-button icon-explore" [routerLink]="['/volumes']"
                        title=" {{'journal_home.explore_button_volumeissue' | translate}}">
                        <span>
                            <!-- <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon> -->
                        </span>
                        {{'journal_home.explore_button_volumeissue' | translate}}
                    </a>
                </div>

            </div>
        </section>

    <!-- ======= Recent Articles Section Ends  ======= -->

    <!-- ======= Search Article Section Starts======= -->
        
        <!-- ======= Loader Starts ======= -->
        <section class="about" aria-label="about" *ngIf="loading">
            <div class="container">
                <div class="card article-search-card ">
                    <div class="card-body article-search-card-body">

                        <div *ngIf="loading" class="section-title  hide-before-after">
                            <div class="d-flex justify-content-center">
                                <h2 class="primary primary-loader loader">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h2>
                            </div>

                        </div>

                        <!--article-search component -->
                        <div class="searchbar" *ngIf="loading">
                            <div class="d-flex justify-content-center">
                                <span class="primary  loader w-100">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </div>
                        </div>

                        <div class="searchlist search-list-loader" *ngIf="loading">
                            <div class="d-flex ">
                                <span class="primary loader w-20 ml-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span class="primary loader w-20 ml-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span class="primary loader w-20 m;-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span class="primary loader w-20 ml-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span class="primary loader w-20 ml-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                <span class="primary loader w-20 ml-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- ======= Loader Ends ======= -->

        <section id="search" class="about" aria-label="about" *ngIf="!loading">
            <div class="container">
                <div class="card article-search-card ">
                    <div class="card-body article-search-card-body">
                        <div class="section-title">
                            <h2 class="primary">{{'journal_home.search_articles' | translate}}</h2>
                        </div>

                        <!--article-search component -->
                        <div class="searchbar" *ngIf="loading">
                            <div class="d-flex justify-content-center">
                                <span class="primary loader w-100">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                            </div>
                        </div>
                        <app-article-search (searchEmit)="searchEmitFunction($event)" [journalid]="journalid"
                            (searchClick)="showSearchedArticle($event)" (clearSearchClick)="clearSearch($event)"
                            (searchListLoader)="searchListLoadeEventReader($event)" [searchLoader]="searchLoader"
                            [selectDiv]="selectDiv" [searchedArticles]="searchedArticles">
                        </app-article-search>
                        <!--article-search component -->

                        <!-- artcile-search-list component -->

                        <app-article-search-list [searchedArticles]="searchedArticles"
                            [tempSearchArticles]="tempSearchArticles" [journalid]="journalid"
                            [valueForSearch]="valueForSearch" [show_search_list]="show_search_list" [loading]="searchLoader"
                            [searchListLoaderContent]="searchListLoader"></app-article-search-list>
                        <!-- artcile-search-list component -->

                        <!-- check box -->
                        <app-article-filters [journalId]="journalid" (emitCheck)="checkBoxChange($event)"
                            [keywordFIlter]="false" [journal_id]="journalid" [subject_area_filter]="subject_area_filter"
                            [volume]="volume_id" [issue]="issue_id" (volumeEmit)="emitedVolume($event)"
                            (issueEmit)="emitedIssue($event)">
                        </app-article-filters>
                        <!-- check box ends-->

                    </div>
                </div>
            </div>
        </section>
    
    <!-- ======= Search Article Section Ends======= -->

    <!-- ======= About Us Section Loader Start ======= -->

        <!-- ======= Loader Starts ======= -->
        <section id="about-loader" class="about about-bg" *ngIf="loading">
            <div class="container">

                <div class="row ">
                    <div class="section-title hide-before-after">
                        <h2 *ngIf="loading" class=" primary">
                            <span class="loader section-title">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        </h2>
                        <div style="min-width: 100%;">
                            <div>
                                <span class="loader about-content">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </div>
                        </div>
                        <!-- <p *ngIf="!loading" class="rvh-sub-heading"> Learn about our Journal's purpose and mission. </p> -->
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-12 col-xxl-12  d-flex justify-content-start align-items-center ">
                        <div *ngIf="loading" style="min-width: 100%;">
                            <div *ngFor="let item of items; let i = index">
                                <span class="loader about-content">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                </span>
                            </div>
                        </div>

                    </div>

                </div>
                <div class="d-flex justify-content-center mt-5" *ngIf="loading">
                    <a class="loader-btn loader">

                        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                    </a>
                </div>
            </div>

        </section>
        <!-- ======= Loader Ends ======= -->

        <section id="about" class="about about-bg" aria-label="about" *ngIf="themeSettingsData.journal_about">
            <div class="container">

                <div class="row ">
                    <div class="section-title  ">
                        <h2 *ngIf="!loading" class="primary">{{'app_header.journal_jba' | translate}}</h2>

                        <p *ngIf="!loading" class="rvh-sub-heading">{{'app_header.journal_jba_sub_title' | translate}} </p>

                    </div>

                    <div class="col-sm-12 col-md-12 d-flex justify-content-center">


                        <p class=" rvh-about-article about-journal-italic ps-4 pe-4" data-aos="fade-up"
                            data-aos-delay="150" *ngIf="!loading" [innerHTML]="themeSettingsData.journal_about">
                        </p>
                    </div>
                </div>

                <div class="d-flex justify-content-center mt-5" *ngIf="!loading" data-aos="fade-up" data-aos-delay="250">
                    <span class="explore-button explore-button-about" (click)="getDynamicMenusJournal(journalid)"
                        title=" {{'app_header.aims'|translate}}">
                        <!-- <span class="icon">
                        <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon>
                    </span> -->
                        {{'app_header.aims'|translate}}
                    </span>
                </div>
            </div>
        </section>

    <!-- ======= About Us Section End ======= -->

    <!-- ======= Editorial Section Start  ======= -->
    
        <!-- ======= Loader Starts ======= -->
        <section id="editorial-loader" class="editorial" aria-label="editorial" *ngIf="loadingForEditorialBoard">

            <div class="container">
                <div class="row ">
                    <div [ngClass]="loadingForEditorialBoard?'section-title hide-before-after col':'section-title col'">
                        <div class="d-flex justify-content-center">

                            <div>
                                <h2 *ngIf="loadingForEditorialBoard" class=" primary">
                                    <span class="loader section-title hide-before-after">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </h2>

                                <p *ngIf="loadingForEditorialBoard" class="rvh-sub-heading">
                                    <span class="loader sub-heading rvh-sub-heading">
                                    </span>
                                </p>

                            </div>
                            <div>
                                &nbsp; &nbsp; &nbsp;
                            </div>
                        </div>

                    </div>

                    <section class=" w-100" id="editor-details" class="p-0 pt-3" *ngIf="loadingForEditorialBoard">
                        <div class="row">
                            <div class="col-12 col-lg-3 col-md-6 col-sm-6 col-xl-3 mx-auto"
                                *ngFor="let item of editorial_items; let i = index">
                                <div class="d-flex justify-content-center">
                                    <div class="d-flex justify-content-center editorial-height">

                                        <div class="editor-details ">
                                            <div class="outer-circle border-0" role="presentation">
                                                <div class="inner-circle ">
                                                    <div class="loading-image-container loader"></div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-center  mt-1">
                                                <span
                                                    class="editor-name loader mt-2 ">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                            </div>
                                            <div class="d-flex justify-content-center  mt-1">
                                                <p class="editor-designation   loader">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </p>
                                            </div>
                                            <div class="d-flex justify-content-center">
                                                <span class="loader ml-1 mt-1"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </span>


                                                <span class="loader ml-1 mt-1">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </span>

                                                <span class="loader ml-1 mt-1">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </span>

                                                <span class="loader ml-1 mt-1">
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </section>
                    <div class="d-flex justify-content-center" *ngIf="loadingForEditorialBoard">
                        <a class="loader-btn  loader">
                            <span class="icon">
                                <!-- <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon> -->
                            </span>
                            &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                            &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <!-- ======= Loader Ends ======= -->

        <section id="editorial" class="editorial" aria-label="editorial" *ngIf="!loadingForEditorialBoard">

            <div class="container" *ngIf="firstHalfeditorialDetails.length!==0">
                <div class="row ">
                    <div [ngClass]="loadingForEditorialBoard?'section-title hide-before-after col':'section-title col'">
                        <div class="d-flex justify-content-center">

                            <div>
                                <h2 *ngIf="!loadingForEditorialBoard && firstHalfeditorialDetails.length!==0"
                                    class="primary ml-3">
                                    {{'journal_home.Editorial_heading'|translate}}
                                </h2>
                                <p *ngIf="!loadingForEditorialBoard && firstHalfeditorialDetails.length!==0"
                                    class="rvh-sub-heading">
                                    {{'journal_home.Editorial_sub_heading'|translate}}
                                </p>
                            </div>
                            <div>
                                &nbsp; &nbsp; &nbsp;
                            </div>
                        </div>

                    </div>
                    <span>
                        <img width="138" height="107"   src="assets/images/graphics.webp" 
                            aria-hidden="true" [alt]="'graphicsimage'">
                    </span>

                    <div class="w-100" id="editor-details" class="p-0 pt-3"
                        *ngIf="!loadingForEditorialBoard && firstHalfeditorialDetails.length!==0">
                        <div class="row">
                            <div class="col-12 col-xl-3 col-lg-6 col-md-6 col-sm-6 mb-5 col-xl-4 mx-auto"
                                *ngFor="let eachdata of firstHalfeditorialDetails; let i=index">
                                <div class="d-flex justify-content-center">
                                    <div class="editor-details">
                                        <div class="outer-circle">
                                            <div class="inner-circle">
                                                <img class="image-container" (click)="getDetails(eachdata)" width="100" height="100" tabindex="0" 
                                                    src="{{editorsImageUrl}}{{eachdata.image}}" [alt]="eachdata.alt_text && eachdata.alt_text !== 'null' ? eachdata.alt_text : 'Editor profile image'" role="button">
                                            </div>
                                            <div class="small-circle"></div>
                                        </div>
                                        <div class="justify-content-center">
                                            <div class="editor-name  pt-2 text-center"
                                                [innerHTML]="checkProfesor(eachdata.name)"></div>
                                            <div class="editor-name  text-center d-flex justify-content-center"
                                                [innerHTML]="checkName(eachdata.name)"></div>
                                        </div>
                                        <!-- <div class="d-flex justify-content-center">
                                            <span class="editor-name pt-2 text-center">{{eachdata.name |
                                                uppercase}}</span>
                                        </div> -->
                                        <div class="d-flex justify-content-center">
                                            <p class="editor-designation m-0 pt-1">{{eachdata.designation}}
                                            </p>
                                        </div>
                                        <div class="d-flex justify-content-center pt-2">
                                            <!-- Tooltip for ORCID -->
                                            <span *ngIf="eachdata.orcid" [ngbTooltip]="eachdata.orcid" placement="bottom">
                                                <img src="assets/logos/orcid_logo.png" class="pl-3 editors-icon" alt="ORCID"
                                                    (click)="openOrcidLink(eachdata.orcid)">
                                            </span>
                                            <!-- Tooltip for Phone -->
                                            <span *ngIf="eachdata.phone" [ngbTooltip]="eachdata.phone" placement="bottom">
                                                <fa-icon [icon]="['fas','phone']" class="pl-3 editors-icon"></fa-icon>
                                            </span>
                                            <!-- Tooltip for Email -->
                                            <span *ngIf="eachdata.email" [ngbTooltip]="eachdata.email" placement="bottom">
                                                <!-- <a [href]="'mailto:' + eachdata.email" target="_blank"> -->
                                                <fa-icon [icon]="['fas','envelope']" class="pl-3 editors-icon"></fa-icon>
                                                <!-- </a> -->
                                            </span>
                                            <!-- Tooltip for Website -->
                                            <span *ngIf="eachdata.website" [ngbTooltip]="eachdata.website"
                                                placement="bottom">
                                                <a target="_blank" [href]="ensureHttps(eachdata.website)"> <fa-icon
                                                        [icon]="['fas','globe']"
                                                        class="pl-3 pr-3 editors-icon"></fa-icon></a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="postion-relative-line"  *ngIf="false"> <!-- *ngIf="secondHalfEditorialDetails.length>0"-->
                            <hr class="underline-hr">
                        </div>
                        <div class="dot-image " *ngIf="false"> <!--*ngIf="secondHalfEditorialDetails.length>0"  -->
                            <img width="138" height="107"   src="assets/images/graphics.webp"
                                [alt]="'graphicsimage'">
                        </div>
                        <!-- Add underline if it's not the last row -->

                        <div class="row ml-5" *ngIf="false">
                            <div class="col-6 col-lg-4 col-md-6 col-sm-6 col-xl-3"
                                *ngFor="let eachdata of secondHalfEditorialDetails; let i=index">
                                <div class="d-flex justify-content-center">
                                    <div class="editor-details">
                                        <div class="outer-circle" role="button" tabindex="0">
                                            <div class="inner-circle">
                                                <img class="image-container" src="{{editorsImageUrl}}{{eachdata.image}}"  width="100" height="100"
                                                    alt="">
                                            </div>
                                            <div class="small-circle"></div>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <span class="editor-name pt-2 text-center">{{eachdata.name |
                                                uppercase}}</span>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <p class="editor-designation  m-0 pt-1">{{eachdata.designation}}
                                            </p>
                                        </div>
                                        <div class="d-flex justify-content-center pt-2">
                                            <!-- Tooltip for ORCID -->
                                            <span *ngIf="eachdata.orcid" [ngbTooltip]="eachdata.orcid" placement="bottom">
                                                <img src="assets/logos/.png" target="_blank" class="pl-3 editors-icon"
                                                    alt="ORCID">
                                            </span>
                                            <!-- Tooltip for Phone -->
                                            <span *ngIf="eachdata.phone" [ngbTooltip]="eachdata.phone" placement="bottom">
                                                <fa-icon [icon]="['fas','phone']" class="pl-3 editors-icon"></fa-icon>
                                            </span>
                                            <!-- Tooltip for Email -->
                                            <span *ngIf="eachdata.email" [ngbTooltip]="eachdata.email" placement="bottom">
                                                <!-- <a [href]="'mailto:' + eachdata.email" target="_blank"> -->
                                                <fa-icon [icon]="['fas','envelope']" class="pl-3 editors-icon"></fa-icon>
                                                <!-- </a> -->
                                            </span>
                                            <!-- Tooltip for Website -->
                                            <span *ngIf="eachdata.website" [ngbTooltip]="eachdata.website"
                                                placement="bottom">
                                                <a target="_blank" [href]="ensureHttps(eachdata.website)"> <fa-icon
                                                        [icon]="['fas','globe']"
                                                        class="pl-3 pr-3 editors-icon"></fa-icon></a>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="d-flex justify-content-center mt-5" *ngIf="!loadingForEditorialBoard" data-aos="fade-up"
                        data-aos-delay="200">
                        <a class="explore-button" [routerLink]="'/editorial-board'"
                            title=" {{'journal_home.explore_more'|translate}}">
                            <span class="icon">
                                <!-- <fa-icon class="long-arrow" [icon]="['fas', 'right-long']" size="2x"></fa-icon> -->
                            </span>
                            {{'journal_home.explore_more'|translate}}
                        </a>
                    </div>
                    <!-- </div> -->
                </div>
            </div>
        </section>
    <!-- ======= Editorial Section End  ======= -->

    <!--======== Call for issue Section Start ======== -->
        
        <!-- ======= Loader Starts ======= -->
        <section id="call-issue-loader" aria-label="explore-content" *ngIf="loaderForNews">
            <div class="container">
                <div class="card article-search-card">
                    <div class="card-body rvh-card-body-callforpaper">
                        <!-- <div class="section-title" data-aos="fade-up">
                            <h2 tabindex="0" class="primary-color">Call For Issue</h2>
                            <p tabindex="0" class="rvh-sub-heading">Duis aute irure dolor in reprehenderit</p>
                        </div> -->

                        <div class="row">
                            <div [ngClass]="loaderForNews?'section-title hide-before-after ':'section-title '">
                                <h2 *ngIf="loaderForNews" class=" primary">
                                    <span class="loader section-title">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </span>
                                </h2>

                                <!-- <p *ngIf="loaderForNews" class="rvh-sub-heading">
                                    <span class="loader sub-heading rvh-sub-heading">
                                    </span>
                                </p>
    -->
                            </div>
                            <!-- First Column -->
                            <div class="col-md-6 col-4">
                                <div class="">
                                    <!-- <h4 class="title loader" style=" font-size: 80px; 
                                        font-weight: bold;margin-left: 9%;" *ngIf="loaderForNews">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h4>

                                
                                    <h3 class="title loader" style=" font-size: 48px;font-weight: 500;margin-left: 9.5%;"
                                        *ngIf="loaderForNews">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </h3> -->

                                    <!-- <img *ngIf="loaderForNews" tabindex="0" class="loader" style=" font-size: 18px; margin-top: 20px; width:20rem ; height:20rem;
                                            font-weight: normal; border:none;
                                            margin-left: 1%;">
                                    -->
                                </div>
                            </div>

                            <!-- Second Column -->
                            <div class="col-md-12 col-12 contentcall">
                                <div class="row">
                                    <!-- <div class="postion-relative-cfs">
                                        <img class="faidcfs" src="assets/images/graphics.webp">
                                    </div> -->
                                    <!-- <div>
                                        <span style="font-size: x-large;" class="loader" *ngIf="loaderForNews">
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                    
                                    </div> -->
                                    <div>
                                        <div *ngIf="loaderForNews">
                                            <div *ngFor="let item of items; let i = index">
                                                <span class="loader about-content"></span>
                                            </div>
                                        </div>
                                        <span class="rvh-csi-content " *ngIf="!loaderForNews && articleData[0]"
                                            [innerHTML]="newsContent">

                                        </span>

                                    </div>
                                    <!-- <div *ngIf="loaderForNews" class="loader">
                                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                        &nbsp;
                                    </div>
                                    -->
                                    <!-- <div *ngIf="loaderForNews" class="loader">
                                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                        &nbsp;
                                    </div>
                                -->
                                    <!-- <div class="d-flex justify-content-center" *ngIf="loaderForNews">
                                        <a class="explore-button loader"> -->
                                    <!-- <span class="icon">
                                                <fa-icon class="long-arrow" [icon]="['fas', 'right-long']"
                                                    size="2x"></fa-icon>
                                            </span> -->
                                    <!-- &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                                        </a>
                                    </div> -->


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- ======= Loader Ends ======= -->

        <section id="call-issue" aria-label="explore-content" *ngIf="!loaderForNews && newsContent">
            <div class="container">
                <div class="card article-search-card">
                    <div class="card-body rvh-card-body-callforpaper">
                        <!-- <div class="section-title" data-aos="fade-up">
                            <h2 tabindex="0" class="primary-color">Call For Issue</h2>
                            <p tabindex="0" class="rvh-sub-heading">Duis aute irure dolor in reprehenderit</p>
                        </div> -->

                        <div class="row" >
                            <div [ngClass]="loaderForNews?'section-title hide-before-after ':'section-title '">

                                <h2 *ngIf="!loaderForNews && articleData[0]" class="primary">{{'app_header.news' |
                                    translate}}
                                </h2>
                            </div>
                            <!-- First Column -->
                            <div class="col-md-6 col-4">
                                <div class="">
                                    <!--

                                    <h4 class="title" style=" font-size: 80px;
                                        font-weight: bold;margin-left: 9%;" *ngIf="!loading">NEWS</h4>
                                    -->
                                    <!-- <h3 class="title" style=" font-size: 48px;font-weight: 500;margin-left: 9.5%;"
                                        *ngIf="!loading">NEWS</h3> -->
                                    <!--
                                    <img *ngIf="!loading" tabindex="0" class="imgcallissues" src="assets/images/loud_speaker.png"
                                        [alt]="'common.default_cover_image'|translate"> -->
                                </div>
                            </div>

                            <!-- Second Column -->
                            <div class="col-md-12 col-12 contentcall">
                                <div class="row">
                                    <!-- <div class="postion-relative-cfs">
                                        <img class="faidcfs" src="assets/images/graphics.webp">
                                    </div> -->
                                    <!-- <div>
                                    
                                        <span class="rvh-csi-titile" *ngIf="!loading && articleData[0]">
                                            Lorem ipsum dolor sit amet, consectetur adipiscing elit
                                        </span>
                                    </div> -->
                                    <div>

                                        <span class="rvh-csi-content" *ngIf="!loaderForNews && articleData[0]"
                                            [innerHTML]="newsContent">

                                        </span>

                                    </div>
                                    <!-- 
                                    <div *ngIf="!loading && articleData[0]">
                                        <span class="rvh-csi-label-one">Submission</span>: <span
                                            class="rvh-csi-rvh-csi-label-two">Open</span>
                                    </div> -->
                                    <!-- 
                                    <div class="mt-3" *ngIf="!loading">
                                        <span class="rvh-csi-label-one">Deadline</span>: <span
                                            class="rvh-csi-rvh-csi-label-two">15 Feb 2024</span>
                                    </div> -->
                                    <!--  -->
                                    <!-- <span class="icon">
                                                <fa-icon class="long-arrow" [icon]="['fas', 'right-long']"
                                                    size="2x"></fa-icon>
                                            </span> -->
                                    <!-- &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                                            &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;
                                        </a>
                                    </div> -->

                                    <!-- <div class="d-flex justify-content-center mt-5 news-left" *ngIf="!loading">
                                        <a class="explore-button">
                                            <span class="icon">
                                                
                                            </span>
                                            Explore More
                                        </a>
                                    </div> -->
                                </div>
                            </div>
                            <!-- <div class="col-md-12 col-12">
                                <div class="d-flex justify-content-center mt-5" *ngIf="!loading" data-aos="fade-up"
                                    data-aos-delay="350">
                                    <a class="explore-button">
                                        <span class="icon">
                                        </span>
                                        {{'journal_home.explore_more'|translate}}
                                    </a>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
    <!--======== Call for issue Section Ends ======== -->


    <!-- ======= Recent Articles Section Start ======= -->
    <!-- <app-article-section [journalid]="journalid" [queryParams]="queryParams" [section]="recent"></app-article-section> -->
    <!-- ======= Recent Articles Section Ends ======= -->

    <!-- ======= Fasttrack Articles Section Start ======= -->
    <!-- <app-article-section [journalid]="journalid" [queryParams]="queryParams" [section]="fasttrack"></app-article-section> -->
    <!-- ======= Fasttrack Articles Section Ends ======= -->

    <!-- ======= Featured Articles Section Start ======= -->
    <!-- <app-article-section [journalid]="journalid" [queryParams]="queryParams" [section]="featured"></app-article-section> -->
    <!-- ======= Featured Articles Section End ======= -->

    <!-- ======= Most Downloaded Articles Section Start ======= -->
    <!-- <app-article-section [journalid]="journalid" [queryParams]="queryParams"
        [section]="most_downloaded"></app-article-section> -->
    <!-- ======= Most Downloaded Articles Section End ======= -->

    <!-- ======= Most Viewed Articles Section Start ======= -->
    <!-- <app-article-section [journalid]="journalid" [queryParams]="queryParams"
        [section]="most_viewed"></app-article-section> -->
    <!-- ======= Most Viewed Articles Section End ======= -->

    <!-- ======= F.A.Q Section Start ======= -->
    <!-- <app-faq-section [journalid]="journalid" *ngIf="faqArray.length!==0"></app-faq-section> -->
    <!-- <section id="faq" class="faq">
        
    </section> -->
    <!-- ======= F.A.Q Section End ======= -->

</main>
<!-- ======= End Main Section ======= -->